import { render, staticRenderFns } from "./TurnTest.vue?vue&type=template&id=6c1acc76&"
import script from "./TurnTest.vue?vue&type=script&lang=js&"
export * from "./TurnTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports